import React, { ReactNode } from 'react'
import { useApplicationContext } from '../../../provider'

interface ExperimentHocPropType {
  children: ReactNode
  experimentName: string
  control?: boolean
}

/**
 * Use this <ExperimentHoc> in MDX file to show content if we are in certain 'name' experiment
 * i.e. <ExperimentHoc experimentName='integrationBuilder'>Show Integration Builder</ExperimentHoc>
 *
 * For if/else condition when the experiment is on or off, you can use it like this
 *   <ExperimentHoc experimentName='A'>If case</ExperimentHoc>
 *   <ExperimentHoc experimentName='A' control>Else clause</ExperimentHoc>
 */
export const ExperimentHoc = ({
  children,
  experimentName,
  control = false,
}: ExperimentHocPropType) => {
  const { experiments } = useApplicationContext()

  const experiment = experiments[experimentName] || ''
  if (control && experiment.startsWith('Ctrl_')) {
    return children
  } else if (!control && experiment.startsWith('Trmt_')) {
    return children
  }

  return <>{children}</>
}

export default ExperimentHoc
